(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-countdown-timer"] && !Shopify.designMode) return;
  try {
    /* Display-only countdown. Prices, promotions, product variants, and cart state are never changed. */
if (!customElements.get('ipg-product-countdown')) {
  customElements.define('ipg-product-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      // Also supports blocks inserted or replaced by the theme editor.
      queueMicrotask(() => {
        if (!this.isConnected || !this._connected || this._started) return;
        this.start();
      });
    }

    start() {
      this._values = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-ipg-time="${unit}"]`));
      if (this._values.some(node => !node)) return;
      const seconds = Number(this.dataset.cycleSeconds);
      const start = Number(this.dataset.cycleStart);
      if (!Number.isSafeInteger(seconds) || seconds < 86400 || seconds > 30 * 86400 || !Number.isSafeInteger(start) || start <= 0) return;
      // The duration is a calendar interval in New York, not a fixed elapsed-hour interval.
      this._duration = seconds * 1000;
      this._anchor = start * 1000;
      this._calendar = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', calendar: 'gregory', numberingSystem: 'latn',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      this._anchorLocal = this.localTime(this._anchor);
      this._periodStart = null;
      this._periodEnd = null;
      this._labels = [this.dataset.daysLabel, this.dataset.hoursLabel, this.dataset.minsLabel, this.dataset.secsLabel];
      this._started = true;
      this._onResume = () => this.resume();
      this._onVisibility = () => {
        if (document.hidden) this.stop();
        else this.resume();
      };
      document.addEventListener('visibilitychange', this._onVisibility);
      window.addEventListener('pageshow', this._onResume);
      this.update();
      this.resume();
    }

    localTime(timestamp) {
      const parts = this._calendar.formatToParts(timestamp);
      const value = name => Number(parts.find(part => part.type === name).value);
      return Date.UTC(value('year'), value('month') - 1, value('day'), value('hour'), value('minute'), value('second'));
    }

    cycleBoundary(index) {
      if (index === 0) return this._anchor;
      // Add calendar days to the original local time, then resolve that date through New York's zone rules.
      const local = this._anchorLocal + index * this._duration;
      const candidates = [-86400000, 86400000].map(delta => {
        const probe = local + delta;
        const instant = local - (this.localTime(probe) - probe);
        return { instant, local: this.localTime(instant) };
      });
      const matches = candidates.filter(candidate => candidate.local === local);
      // A repeated hour uses its first occurrence; a skipped hour moves forward by the gap.
      if (matches.length) return Math.min(...matches.map(candidate => candidate.instant));
      return candidates.filter(candidate => candidate.local > local).sort((a, b) => a.local - b.local)[0].instant;
    }

    update() {
      const now = Math.max(Date.now(), this._anchor);
      // The shared anchor and New York calendar keep every product page on the same recurring schedule.
      if (this._periodEnd === null || now < this._periodStart || now >= this._periodEnd) {
        let index = Math.max(0, Math.floor((this.localTime(now) - this._anchorLocal) / this._duration));
        let start = this.cycleBoundary(index);
        while (index > 0 && now < start) start = this.cycleBoundary(--index);
        let end = this.cycleBoundary(index + 1);
        while (now >= end) {
          start = end;
          end = this.cycleBoundary(++index + 1);
        }
        this._periodStart = start;
        this._periodEnd = end;
      }
      const remaining = this._periodEnd - now;
      const total = Math.ceil(remaining / 1000);
      const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
      values.forEach((value, index) => {
        const text = String(value).padStart(2, '0');
        if (this._values[index].textContent !== text) this._values[index].textContent = text;
      });
      const label = values.map((value, index) => `${value} ${this._labels[index] || ''}`.trim()).join(', ');
      const timer = this.querySelector('[role="timer"]');
      if (timer && timer.getAttribute('aria-label') !== label) timer.setAttribute('aria-label', label);
    }

    resume() {
      this.stop();
      if (!this.isConnected || !this._started) return;
      this.update();
      if (!document.hidden) {
        // Recompute from wall time rather than decrementing a counter, so a suspended tab stays accurate.
        this._timer = setTimeout(() => this.resume(), 1010 - (Date.now() % 1000));
      }
    }

    stop() {
      clearTimeout(this._timer);
      this._timer = null;
    }

    disconnectedCallback() {
      this.stop();
      if (this._onVisibility) document.removeEventListener('visibilitychange', this._onVisibility);
      if (this._onResume) window.removeEventListener('pageshow', this._onResume);
      this._connected = false;
      this._started = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
